import { Skeleton, Stack } from '@mui/material';

export const AddressSelectionSkeleton = () => (
	<Stack direction="column" spacing={0} paddingTop={'18px'}>
		<Skeleton variant="text" width={250} height={43} />
		<Skeleton variant="text" width={'auto'} height={43} />
		<Skeleton variant="text" width={'auto'} height={21} />
		<Skeleton variant="text" width={'auto'} height={98} />
		<Skeleton variant="text" width={250} height={43} />
		<Skeleton variant="text" width={'auto'} height={53} />
		<Skeleton variant="text" width={'auto'} height={98} />
	</Stack>
);
